const INITIAL_STATE = {message: null, hidden: false};

export function reducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case "SUBSCRIPTION_DATA_ARRIVED/USER_IDENTITY":
            return {
                message: action.payload.systemBroadcastMessage,
                hidden: state.hidden && state.message === action.payload.systemBroadcastMessage
            };
        case "SYSTEM_BROADCAST_MESSAGE/DISMISS":
            return {...state, hidden: true};
        default:
            return state;
    }
}

export function dismissSystemBroadcastMessage() {
    return {type: "SYSTEM_BROADCAST_MESSAGE/DISMISS"};
}
